


























































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import DateUtils from '@/common/js/DateUtils'
    import Enums from '@/lib/enums'
    import { routers } from '@/router/router'
    import Quagga from 'quagga'; // ES6
    import PageRequest from '@/store/entities/page-request'
    import PageResult from '@/store/entities/page-result'
    import BackMainLandOrderList from '@/store/entities/order-back-list'
    import CreateOrderProductInfo from '@/store/entities/create-order-product';
    import Preview from 'vue-photo-preview'
    import 'vue-photo-preview/dist/skin.css'
    Vue.use(Preview);
    class TakePictureInput {
        orderNumber: string;
        packedImageGuid: string;
    }
    @Component({
        name: "uploadpackageimg",
    })
    export default class OrderScan extends AbpBase {
        resultCode: string = "";
        resultOrderNumber: string = "";
        resultError: string = "";
        imageGuidUrl: string = "";
        base64: string = "";
        deliveredLoding: Boolean = false;
        isCheck: Boolean = false;
        processTakePictureInput: TakePictureInput = new TakePictureInput();
        orderData: BackMainLandOrderList = null;
        orderProductInfoList: Array<CreateOrderProductInfo> = [];
        createData() {
            var _this = this;
      
        }
        async check() {
            var orderNumber = abp.getQueryVariable("orderNumber");
            if (orderNumber) {
                this.resultCode = orderNumber;
            }
            var _this = this;
            this.isCheck = true;
            this.orderData = await this.$store.dispatch({
                type: 'backmainlandorder/getSearchPackedOrder',
                data: { tradeNo: this.resultCode }
            });

            if (this.orderData != null) {
                this.resultOrderNumber = _this.orderData.orderNumber;
                this.orderProductInfoList = _this.orderData.orderProductInfoList;
                if (_this.orderData.weightImageUploadGuid != "") {
                    this.processTakePictureInput.packedImageGuid = _this.orderData.weightImageUploadGuid;
                    var data = { imageGuid: _this.orderData.weightImageUploadGuid, url: null };
                    this.$store.commit('backlogistics/getImgUrl', data);
                    this.imageGuidUrl = data.url;
                }
            }
            else {
                this.$Message.error("订单信息不存在，检查快递单号是否有误！");
                return;
            }
        }
        rescan() {
            location.reload();
        }
        async takeGoodsImageGuidPhoto(e) {//拍照功能---上传头像
            var file = e.target.files[0]//获取文件对象
            //alert(file.size);
            //if (file.size / 1024 > 1024) {
            //    this.$Message.info("图片过大不支持上传");
            //}
            var _this = this;
            let reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function (e) {
                let image = new Image() //新建一个img标签（还没嵌入DOM节点)
                image.src = e.target.result.toString()
                image.onload = function () {
                    let canvas = document.createElement('canvas'),
                        context = canvas.getContext('2d'),
                        imageWidth = image.width / 2,    //压缩后图片的大小
                        imageHeight = image.height / 2,
                        data = ''

                    canvas.width = imageWidth
                    canvas.height = imageHeight

                    context.drawImage(image, 0, 0, imageWidth, imageHeight)
                    _this.base64 = canvas.toDataURL('image/jpeg', 0.8);
                    _this.LoadImg();

                }

            }




            //this.imageGuidUrl = base64;



            //var fd = new FormData();//构造formdata对象
            //fd.append('file', base64) //向formdata里面存放键值对

        }
        async LoadImg() {
            var _this = this;
            this.processTakePictureInput.packedImageGuid = await this.$store.dispatch({
                type: 'backmainlandorder/uploadpackedImg',
                data: { baseString: _this.base64 }
            });

            var data = { imageGuid: this.processTakePictureInput.packedImageGuid, url: null };
            this.$store.commit('backmainlandorder/getImgUrl', data);
            this.imageGuidUrl = data.url;
        }
        async save() {
            this.processTakePictureInput.orderNumber = this.resultOrderNumber;
            var b = await this.$store.dispatch({
                type: 'backmainlandorder/setTakePicture',
                data: this.processTakePictureInput
            })
            if (b) {
                this.$Message.success('保存成功');
            }
        }
        async delivered() {
            this.deliveredLoding = true;
            await this.$store.dispatch({
                type: 'backorder/ ',
                data: { tradeNo: this.resultCode }
            }).finally(() => {
                this.deliveredLoding = false;
            });
            this.resultCode = '';
            this.$emit('save-success');
        }
        stop() {
            Quagga.stop();
        }

        HideMenu() {
            var _this = this;
            var menu: any = document.querySelector("div[class='sidebar-menu-con']");
            var head: any = document.querySelector("div[class='main-header-con']");
            var page: any = document.querySelector("div[class='single-page-con']");
            if (menu && head && page) {
                head.style.display = "none";
                menu.style.display = "none";
                page.style.top = "0px";
                page.style.left = "0px";
            } else {
                setTimeout(function () { _this.HideMenu() }, 200);
            }
        }
        async created() {


            if (abp.isMobile()) {
                abp.hideMenu();
            }

            if (abp.getQueryVariable("orderNumber")) {
                this.check();
            }

        }
    };
